import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import _ from "lodash";

interface Items {
  key: string;
  value: string;
}

interface ISelectedSkill {
  name: string
  subcategories: string[]
}

interface ISkillCategory {
  id: string
  type: string
  attributes: {
      id: number
      name: string
  }
}

interface ISkillSubCategory {
  id: string
  type: string
  attributes: {
      id: number
      name: string
      category_id: number
      category_name: string
  }
}

interface ISkillsCategoriesSuccessRes {
  data: ISkillCategory[]
}

interface ISkillsSubCategoriesSuccessRes {
  data: ISkillSubCategory[]
}

interface ISkillsSubCategoriesErrorRes {
  errors: string
}

interface ILanguageSpoken {
  id: number
  name: string
  created_at: string
}

interface IErrorResponse {
  errors: string[]
}

export enum FilterTypes {
  Skills= "Skills",
  Location= "Location" ,
  Gender= "Gender",
  AgeRange = "AgeRange",
  LanguageSpoken = "Language Spoken"
}

interface IFilterAndSortTags {
  type: "Sort" | "Filter";
  label: string;
  subLabel?: FilterTypes
  value: string | string[]
}
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  id: string;
  // Customizable Area Start
  filtersList: IFilterAndSortTags[];
  handleFilterChange: (
    filterType: FilterTypes,
    value: string | string[],
    subLabel?: FilterTypes
  ) => void;
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  selectedGender: string | null;
  locations: Items[];
  selectedLocation: string | null;
  selectedAgeRange: string[];
  languages: Items[];
  selectedLanguages: string[];
  skillsCategories: string[]
  isGettingSubCategories: boolean
  skillsSubCategories: string[]
  selectedSkills: ISelectedSkill[];
  // Customizable Area End
}

interface SS {
  id: any;
}

export default class FiltersController extends BlockComponent<
  Props,
  S,
  SS
> {
    // Customizable Area Start
    languagesListingApiCallId: string = ""
    locationsListingApiCallId: string = ""
    categoryListingApiCallId: string = ""
    subCategoryListingApiCallId: string = ""
    // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.handleSkillsChange = this.handleSkillsChange.bind(this);
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.state = {
      selectedGender: "",
      locations: [],
      selectedLocation: "",
      selectedAgeRange: [],
      languages: [],
      selectedLanguages: [],
      skillsCategories: [],
      isGettingSubCategories: false,
      skillsSubCategories: [],
      selectedSkills: [],
    };
    // Customizable Area End
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }
  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    this.handlePageLoadApiCalls()
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    const apiRequestCalId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    )

    if(apiRequestCalId === this.languagesListingApiCallId) {
      this.handleLanguagesApiResponse(responseJson)
    }

    if(apiRequestCalId === this.locationsListingApiCallId) {
      this.handleLocationsApiResponse(responseJson)
    }

    if(apiRequestCalId ===  this.categoryListingApiCallId) {
      this.handleSkillsCategoriesApiResponse(responseJson)
    }

    if(apiRequestCalId ===  this.subCategoryListingApiCallId) {
      this.handleSkillsSubCategoriesApiResponse(responseJson)
    }
    // Customizable Area End
  }
  
  // Customizable Area Start
  async componentDidUpdate(prevProps: Readonly<Props>): Promise<void> {
    const { filtersList } = this.props

    const isSameFilters = _.isEqual(prevProps.filtersList, filtersList)
    if(!isSameFilters) {
      this.handleUpdatedFilters()
    }
  }

  handleUpdatedFilters = () => {
    const { filtersList } = this.props;
  
    const selectedData: {
      selectedSkills: ISelectedSkill[];
      selectedGender: string;
      selectedLocation: string;
      selectedAgeRange: string[];
      selectedLanguages: string[];
    } = {
      selectedSkills: [],
      selectedGender: "",
      selectedLocation: "",
      selectedAgeRange: [],
      selectedLanguages: [],
    };
  
    const keyMap: Record<FilterTypes, keyof typeof selectedData> = {
      [FilterTypes.Gender]: "selectedGender",
      [FilterTypes.Location]: "selectedLocation",
      [FilterTypes.AgeRange]: "selectedAgeRange",
      [FilterTypes.LanguageSpoken]: "selectedLanguages",
      [FilterTypes.Skills]: "selectedSkills",
    };
  
    filtersList
      .filter(({ type }) => type !== "Sort")
      .forEach(({ label, subLabel, value }) => {
        if (label === FilterTypes.Skills) {
          selectedData.selectedSkills.push({
            name: subLabel as string,
            subcategories: typeof value === "string" ? [value] : value
          });
        } else {
          const stateKey = keyMap[label as FilterTypes];
  
          if (stateKey === "selectedAgeRange" || stateKey === "selectedLanguages") {
            selectedData[stateKey] = Array.isArray(value) ? value : [];
          } else if (stateKey === "selectedGender" || stateKey === "selectedLocation") {
            selectedData[stateKey] = typeof value === "string" ? value : "";
          }
        }
      });
  
    this.setState(selectedData);
  }  

  handlePageLoadApiCalls = () => {
    this.getSkillsCategoriesApi()
    this.getLocationsApi()
    this.getSpokenLanguagesApi()
  }

  handleGenderChange = (selectedGender: string | null) => {
    this.setState({ selectedGender });
    this.props.handleFilterChange(FilterTypes.Gender, selectedGender as string)
  };

  handleLocationChange = (selectedLocation: string | null) => {
    this.setState({ selectedLocation });
    this.props.handleFilterChange(FilterTypes.Location, selectedLocation as string)
  };

  handleAgeRangeChange = (selectedAgeRange: string[]) => {
    this.setState({ selectedAgeRange });
    this.props.handleFilterChange(FilterTypes.AgeRange, selectedAgeRange)
  };

  handleLanguageChange = (selectedLanguages: string[]) => {
    this.setState({ selectedLanguages });
    this.props.handleFilterChange(FilterTypes.LanguageSpoken, selectedLanguages)
  };

  handleSkillsChange = (categoryName: string, subcategory: string) => {
    this.setState((prevState) => {
      let selectedSkills = [...prevState.selectedSkills];
      let categoryIndex = selectedSkills.findIndex(skill => skill.name === categoryName);
  
      if (categoryIndex !== -1) {
        let subcategories = selectedSkills[categoryIndex].subcategories;
        let subcategoryIndex = subcategories.indexOf(subcategory);
  
        if (subcategoryIndex !== -1) {
          subcategories.splice(subcategoryIndex, 1);
        } else {
          subcategories.push(subcategory);
        }
  
        if (subcategories.length === 0) {
          selectedSkills.splice(categoryIndex, 1);
        }
      } else {
        selectedSkills.push({ name: categoryName, subcategories: [subcategory] });
      }
  
      return { selectedSkills };
    });
    this.props.handleFilterChange(FilterTypes.Skills, subcategory, categoryName as FilterTypes)
  };

  handleCategoryClick = (categoryName: string) => {
    const query = new URLSearchParams({ category_name: categoryName }).toString();
    this.setState({ isGettingSubCategories: true })
    this.getSkillsSubCategoriesApi(query)
  }

  getSkillsCategoriesApi = () => {
    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.categoryListingApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.skillsCategoriesApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getSkillsSubCategoriesApi = (query: string) => {
    const endpoint = `${configJSON.skillsCategoriesApiEndPoint}?${query}`

    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.subCategoryListingApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      endpoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getSpokenLanguagesApi = () => {
    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.languagesListingApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.languagesSpokenApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getLocationsApi = () => {
    const header = {
      "Content-Type": configJSON.productApiContentType,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.locationsListingApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.locationsApiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.apiMethodTypeGet
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleSkillsCategoriesApiResponse = (
    responseJson: ISkillsCategoriesSuccessRes | IErrorResponse
  ) => {
    if ("data" in responseJson) {
      const categories = responseJson.data.map((category) => category.attributes.name)
      this.setState({ skillsCategories: categories })
    }
  }

  handleSkillsSubCategoriesApiResponse = (
    responseJson: ISkillsSubCategoriesSuccessRes | ISkillsSubCategoriesErrorRes
  ) => {
    if ("data" in responseJson) {
      const subCategories = responseJson.data.map(
        (subCategory) => subCategory.attributes.name
      );
      this.setState({
        skillsSubCategories: subCategories,
        isGettingSubCategories: false,
      });
    } else {
      this.setState({ skillsSubCategories: [], isGettingSubCategories: false });
    }
  }

  handleLanguagesApiResponse = (
    responseJson: ILanguageSpoken | IErrorResponse
  ) => {
    if (Array.isArray(responseJson)) {
      const formattedList = responseJson.map((languageInfo) => {
        const { name } = languageInfo
        return {
          key: name,
          value: name
        }
      })
      this.setState({ languages: formattedList });
    }
  }

  handleLocationsApiResponse = (
    responseJson: string[] | IErrorResponse
  ) => {
    if (Array.isArray(responseJson)) {
      const locations = responseJson.map((location) => {
        return {
          key: location,
          value: location
        }
      })
      this.setState({ locations });
    }
  }
  // Customizable Area End
}
